import React, { useMemo } from 'react';
import UnstyledButton from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/UnstyledFilterButton';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useAppSelector } from 'src/utils/Hooks';
import { useAppFilterModalStore } from 'src/zustandStores/BeaconPro/AppFilterStore';

export default function SubtitleFilters({ showFilterNumber = true }: { showFilterNumber?: boolean }) {
  const filters = useAppSelector((state) => state.filters);
  const category = filters?.category;
  const subcategory = filters?.subcategory;
  const businessUnits = filters?.businessUnits;
  const segment = filters?.segment;
  const retailPrice = filters?.retailPrice;

  const { openModal } = useAppFilterModalStore();
  const totalFilters = useMemo(() => {
    const categoryFilterCount = category?.length || 0;
    const subcategoryFilterCount = subcategory?.length || 0;
    const businessUnitFilterCount = businessUnits?.length || 0;
    const segmentFilterCount = segment?.id != null ? 1 : 0;
    const retailPriceFilterCount =
      retailPrice &&
        ['min', 'max', 'minValue', 'maxValue'].some((key) => retailPrice[key] !== undefined && retailPrice[key] !== null)
        ? 1
        : 0;

    return (
      categoryFilterCount +
      subcategoryFilterCount +
      businessUnitFilterCount +
      segmentFilterCount +
      retailPriceFilterCount
    );
  }, [businessUnits, category, retailPrice, segment, subcategory]);

  if (totalFilters <= 0) {
    return <></>;
  }

  const renderText = totalFilters === 1 || !showFilterNumber ? 'Edit filter' : `Edit ${totalFilters} filters`;

  return (
    <>
      {' '}
      <UnstyledButton style={{ display: 'inline', whiteSpace: 'nowrap' }}>
        <Text sx={{ display: 'inline' }} underlined variant="body1" onClick={() => openModal()}>
          {renderText}
        </Text>
        <Text sx={{ display: 'inline' }} variant="body1">
          .
        </Text>
      </UnstyledButton>
    </>
  );
}
